import { useAtom } from '@reatom/npm-react'
import { StyleSheetManager, ThemeProvider } from 'styled-components'
import { Normalize } from 'styled-normalize'

import { GlobalStyles, TooltipProvider } from '@blade/ui-kit'
import { SnackbarShortcutsHint } from '@root/features/shortcut/ui/possible-shortcut'
import { ErrorBoundary } from '@root/shared/layout'
import { currentThemeAtom } from '@root/shared/theme/atoms/current-theme-atom'
import { SnackbarProvider } from '@root/shared/ui-kit'

import { AppGlobalStyles } from './ui/global-styles'

import type { ChildrenProps } from '@root/shared/react'

export const AppProviders = ({ children }: ChildrenProps) => {
  const [currentTheme] = useAtom(currentThemeAtom)
  return (
    <StyleSheetManager enableVendorPrefixes>
      <ThemeProvider theme={currentTheme}>
        <TooltipProvider delayDuration={200}>
          <Normalize />
          <GlobalStyles />
          <AppGlobalStyles />
          <ErrorBoundary global={true}>{children}</ErrorBoundary>
        </TooltipProvider>
        <SnackbarProvider>
          <SnackbarShortcutsHint />
        </SnackbarProvider>
      </ThemeProvider>
    </StyleSheetManager>
  )
}
